'use strict';

import Loader from '../../../_modules/loader/loader';

import { isFieldEmpty, displayErrors, delay, getErrorMessage } from './_helper';
import { toaster } from './_material';

let $transferClient = $('#transfer-client-details'),
	$succesTransfer = $('#transfer-client--success'),
	$institutionSelect = $('#TransferToInstitution'),
	$hcpSelect = $('#TransferToHcp'),
	$suggestions = $('.form--suggestions-transfer'),
	$agreeBtnWrapper = $('.transfer-client__agree-btn'),
	$clientAgreeTransfer = $('#ClientAgreeTransfer'),
	$transferBtnWrapper = $('.transfer-client__btn'),
	$notFoundBtnWrapper = $('.transfer-client__not-found-btn'),
	clientId = $('#ClientId').val(),
	currentInstitutionId = $('#CurrentInstitutionId').val(),
	clientName = $('#ClientName').val(),
	selectedInstName = '',
	loader = new Loader(),
	_isInvalid = [],
	formSuggestionHtml  = '',
	formSuggestionTmp = '';

$(() => {
    if (!$transferClient.length) {
        return false;
    }

    //To display list of Institutions
    formSuggestionTmp = doT.template($('#institution-transfer-tmp').html());

    //display list of suggested institutions
    $institutionSelect.on('keyup', function(){

    	let $this = $(this),
    		$errorContainer = $('.server-errors__wrap--transfer'),
	    	dataParams = {'name': $this.val()},
	    	obj = {},
	    	formSuggestionHtml = '',
	    	_filteredData = [];

	    $notFoundBtnWrapper.fadeIn();

    	delay( "check date", function(){ 

	    	loader.fadeIn();

	    	var encodedParams = jQuery.param(dataParams);
	    	$.ajax({
		        url: '/api/institutions?'+encodedParams,
		        dataType: 'json',
		        contentType: 'application/json; charset=utf-8',
		        headers: { __RequestVerificationToken: $('.transfer-client').find('input[name=__RequestVerificationToken]').val() },
		        type: 'GET',
		        success: function (data) {

		        	$suggestions.addClass('active');

		        	if (!data.length) {
						//Fade out loader, display no results
						loader.fadeOut();
						toaster('No results found.', 'error');		
		                $suggestions.removeClass('active');
		                return false;
		            }

		            // remove current institution from the list of available institutions
		            _filteredData = $.grep(data, function(e){ 
		                 return e.InstitutionId != currentInstitutionId; 
		            });

		            //prepare data to display in the list
		            for (let i = 0, l = _filteredData.length; i < l; i++) {

		                obj = {
		                    "id": _filteredData[i].InstitutionId,
		                    "name": _filteredData[i].InstitutionName,
		                    "state": _filteredData[i].State
		                };

		                formSuggestionHtml += formSuggestionTmp(obj);
		            }

		            //display list
		            $('.form--transfer-suggested').html(formSuggestionHtml);

		        	loader.fadeOut();

		            $errorContainer.slideUp({
		                duration: 500,
		                easing: 'easeInOutExpo',
		                queue: false
		            });
		        },
		        error: function (error) {
		            loader.fadeOut();
		            displayErrors(error, $errorContainer );
		        }
		    });

	    } ,600);
    });

    //populate list of HCP based on selected institution
    $('body').on('click', '.js-populate-transfer-hcp', function (e) {

    	let $this = $(this),
    		selectedInstitution = $this.data('name'),
    		dataParams = {'institutionId': $this.data('index')};

    	$suggestions.removeClass('active');

    	$clientAgreeTransfer
    		.prop('checked', false)
    		.parent().removeClass('checked');

    	$notFoundBtnWrapper.fadeOut();

    	//display selected institution
    	$institutionSelect
    		.val(selectedInstitution)
    		.trigger('blur');

    	loader.fadeIn();

    	// clear dropdown from previous values
	    $hcpSelect
	        .empty()
	        .append(
	            $('<option></option>')
	                .text('HCP Name')
	                .val('')
	        );

    	var encodedParams = jQuery.param(dataParams);
    	$.ajax({
    		url: '/api/hcpworkplaces/approvedhcpsbyinstitution?'+encodedParams,
	        dataType: 'json',
	        contentType: 'application/json; charset=utf-8',
	        type: 'GET',
	        success: function (data) {

	        	//to populate HCP dropdown
	        	$.each(data, function(index, item){
	        		$hcpSelect.append(
	        			$('<option></option>')
	        				.text(item.value)
	        				.val(item.key)
	        		);	
	        	});

	        	loader.fadeOut();

	            $hcpSelect.fadeIn();
	        },
	        error: function (error) {
	            loader.fadeOut();
	        }
	    });

    });

    $('.js-not-listed').on('click', function(e){
    	e.preventDefault();

    	let $this = $(this),
    		$message = $this.siblings('p');

    	$institutionSelect.val('');
    	$suggestions.removeClass('active');
    	$agreeBtnWrapper.hide();
    	$hcpSelect.hide();
    	$transferBtnWrapper.hide();

    	$message.slideDown({
            duration: 500,
            easing: 'easeOutExpo',
            queue: false
        });
    });

    // to display agreement checkbox
    $hcpSelect.on('change', function (e){
    	e.preventDefault();

    	$agreeBtnWrapper.fadeIn();
    });

    // to display transfer button
    $clientAgreeTransfer.on('change', function (e){
    	e.preventDefault();

    	$transferBtnWrapper.fadeIn();
    });

    //call transfer API and set new values
    $('.js-transfer-client').on('click', function(e){
    	e.preventDefault();

    	_isInvalid = [];
    	selectedInstName = $institutionSelect.val();

    	if($institutionSelect.val() == ''){
    		$InstitutionSelect
    			.parent().addClass('incomplete')
                .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

            _isInvalid.push(0);
    	}

    	if(isFieldEmpty($hcpSelect)){
    		$hcpSelect
    			.parent().addClass('incomplete')
                .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

            _isInvalid.push(0);
    	}

    	if(!$clientAgreeTransfer.prop('checked')){
    		toaster('Patient must agree to be transferred.', 'error');
    		_isInvalid.push(0);
        }

    	if (_isInvalid.length > 0) {
            $(this).addClass('error');
            return false;
        } else {

        	let dataParams = {
        		'ClientId': clientId,
        		'HcpWorkplaceId': $hcpSelect.val()
        	};

            _isInvalid = [];

            $(this).removeClass('error');

            loader.fadeIn();

            var encodedParams = jQuery.param(dataParams);
            $.ajax({
		        url: '/api/clients/transfer',
		        dataType: 'json',
		        contentType: 'application/json; charset=utf-8',
		        type: 'PUT',
		        headers: { __RequestVerificationToken: $('.transfer-client').find('input[name=__RequestVerificationToken]').val() },
                data: JSON.stringify(dataParams),
		        success: function (data) {

		        	// hide previous section and change trigger to close btn
		        	$transferClient.hide();
		        	$('.transfer-client__dropdown')
		        		.find('.form-modal__btn-close')
		        		.removeClass('js-collapse-form-modal')
		        		.addClass('js-close-transfer')

		        	// set text and display successful transfer
		        	$succesTransfer
		        		.find('p')
		        		.text( clientName + ' has been successfully transferred to ' + selectedInstName);
		        	
		        	$succesTransfer.fadeIn();	

		        	loader.fadeOut();

		        	// redirect user to updated page if clicking on either "OK" or close btn
		        	$('.js-close-transfer').on('click', function(e){
		        		window.location.href = data.href;
		        	});
		        },
		        error: function (error) {
		            loader.fadeOut();
		            toaster(getErrorMessage(error));
		        }
		    });
		}

    });

});  